<template>
	<el-card class="productCourse">
		<div v-show="!dialogVisible">
			<!-- 搜索框 -->
			<el-form
				ref="tableFilter"
				class="clearfloat"
				inline
				:model="tableFilter"
			>
				<el-form-item prop="title">
					<el-input
						size="small"
						v-model="tableFilter.title"
						placeholder="标题"
					></el-input>
				</el-form-item>
				<el-form-item prop="productId">
					<el-select
						size="mini"
						v-model="tableFilter.productId"
						placeholder="产品型号"
						clearable
					>
						<el-option
							v-for="item in productModels"
							:key="item.id"
							:value="item.id"
							:label="item.productModel"
						></el-option>
					</el-select>
				</el-form-item>
				<el-form-item prop="type">
					<el-select
						size="small"
						v-model="tableFilter.type"
						placeholder="类型"
						clearable
					>
						<el-option
							v-for="item in $staticData.courseTypes"
							:key="item.value"
							:value="item.value"
							:label="item.label"
						></el-option>
					</el-select>
				</el-form-item>
				<el-form-item prop="source">
					<el-select
						size="small"
						v-model="tableFilter.source"
						placeholder="APP来源"
						clearable
					>
						<el-option
							v-for="item in source"
							:key="item.value"
							:value="item.value"
							:label="item.label"
						></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button size="small" @click="handleResetFilter">
						重置
					</el-button>
					<el-button type="primary" size="small" @click="getList">
						搜索
					</el-button>
				</el-form-item>
				<el-button
					class="right"
					type="primary"
					size="small"
					v-if="btnPer('com_addCourse')"
					@click="handleAdd"
					>添加</el-button
				>
			</el-form>
			<!-- 表格 -->
			<el-table :data="tableData" style="width: 100%">
				<el-table-column
					label="序号"
					width="50"
					type="index"
				></el-table-column>
				<el-table-column label="标题" prop="title">
					<template slot-scope="scope">{{
						dealTableData("", scope.row.title)
					}}</template>
				</el-table-column>
				<el-table-column label="产品型号" prop="productName">
					<template slot-scope="scope">{{
						dealTableData("", scope.row.productName)
					}}</template>
				</el-table-column>
				<el-table-column label="类型" prop="type">
					<template slot-scope="scope">{{
						$utils.escapeCourse(scope.row.type)
					}}</template>
				</el-table-column>
				<el-table-column label="APP来源" prop="source">
					<template slot-scope="scope">{{
						dealTableData("source", scope.row.source)
					}}</template>
				</el-table-column>
				<el-table-column :min-width="200" label="操作">
					<template slot-scope="scope">
						<el-link
							type="primary"
							v-if="btnPer('com_editCourse')"
							size="small"
							class="marginR10"
							@click="handleEdit(scope.row)"
						>
							编辑
						</el-link>
						<el-link
							type="primary"
							v-if="btnPer('com_previewCourse')"
							size="small"
							class="marginR10"
							@click="handlePreview(scope.row)"
						>
							预览
						</el-link>
						<el-link
							type="primary"
							class="marginR10"
							v-if="
								scope.row.url != undefined &&
								scope.row.url != null &&
								btnPer('com_courseHrefCopy')
							"
							v-clipboard:error="handleCopyError"
							v-clipboard:copy="scope.row.url"
							v-clipboard:success="handleCopySuccess"
						>
							复制链接
						</el-link>
						<el-link
							type="danger"
							v-if="btnPer('com_deleteCourse')"
							size="small"
							@click="handleDelete(scope.row)"
						>
							删除
						</el-link>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页 -->
			<el-pagination
				class="pagination marginT20"
				align="right"
				@size-change="(pageSize) => getList('pageSize', pageSize, true)"
				@current-change="(page) => getList('page', page)"
				:current-page.sync="tableFilter.page"
				:page-sizes="[10, 20, 30, 40]"
				:page-size.sync="tableFilter.pageSize"
				layout="total, sizes, prev, pager, next, jumper"
				:total="total"
			></el-pagination>
		</div>
		<div v-if="dialogVisible">
			<!-- 表单 -->
			<el-form
				ref="form"
				:model="form"
				label-width="150px"
				:rules="rules"
			>
				<!-- 标题 -->
				<el-form-item label="标题" prop="title">
					<el-input
						size="small"
						class="formInput"
						v-model="form.title"
					></el-input>
				</el-form-item>
				<!-- 类型 -->
				<el-form-item label="类型" prop="type">
					<el-select
						size="small"
						v-model="form.type"
						@change="handleChangeType"
					>
						<el-option
							v-for="item in $staticData.courseTypes"
							:key="item.value"
							:value="item.value"
							:label="item.label"
						></el-option>
					</el-select>
				</el-form-item>
				<!-- 产品型号 -->
				<el-form-item
					label="产品型号"
					v-show="form.type == 1 || form.type == 2 || form.type == 5 || form.type == 6"
					prop="productId"
				>
					<el-select size="small" v-model="form.productId">
						<el-option
							v-for="item in productModels"
							:key="item.id"
							:value="item.id"
							:label="item.productModel"
						></el-option>
					</el-select>
				</el-form-item>
				<!-- app来源 -->
				<el-form-item
					v-show="form.type == 3 || form.type == 4"
					label="APP来源"
					prop="source"
				>
					<el-select size="mini" v-model="form.source">
						<el-option
							v-for="item in source"
							:key="item.value"
							:value="item.value"
							:label="item.label"
						></el-option>
					</el-select>
				</el-form-item>
				<!-- URL -->
				<el-form-item label="URL" prop="url">
					<el-input
						size="mini"
						v-model="form.url"
						disabled
					></el-input>
				</el-form-item>
				<!-- 富文本 -->
				<el-form-item label="内容" prop="html">
					<vue-tinymce
						class="mce"
						v-model="form.html"
						:setting="setting"
					/>
				</el-form-item>
			</el-form>
			<span>
				<el-button @click="handleClose">取 消</el-button>
				<el-button type="primary" @click="beforeSubmit">确认</el-button>
			</span>
		</div>
	</el-card>
</template>

<script>
import { Message } from "element-ui";
export default {
	name: "productCourse",
	data() {
		var checkUrl = (rule, value, callback) => {
			if (this.$utils.checkUrl(value)) {
				callback(new Error("请输入正确的网址"));
			} else {
				callback();
			}
		};
		var checkProductId = (rule, value, callback) => {
			if (
				this.form.type == 1 ||
				this.form.type == 2 ||
				this.form.type == 5 ||
				this.form.type == 6
			) {
				if (value == "" || value == null) {
					callback(new Error("请选择产品类型"));
				} else {
					callback();
				}
			} else {
				callback();
			}
		};
		var checkSource = (rule, value, callback) => {
			if (this.form.type == 3 || this.form.type == 4) {
				if (value == "" || value == null) {
					callback(new Error("请选择APP来源"));
				} else {
					callback();
				}
			} else {
				callback();
			}
		};
		return {
			source: this.$store.state.standard.sourcesPart,
			domain: "",
			total: 0,
			act: "",
			dialogVisible: false,
			tableFilter: {
				productId: null,
				source: null,
				title: null,
				type: null,
				page: 1,
				pageSize: 10,
			},
			form: {
				productId: "",
				html: "",
				title: "",
				url: "",
				source: "",
				type: "",
			},
			rules: {
				html: [
					{
						required: true,
						message: "请输入富文本内容",
						trigger: "blur",
					},
				],
				source: [{ validator: checkSource, trigger: "blur" }],
				productId: [{ validator: checkProductId, trigger: "blur" }],
				type: [
					{
						required: true,
						message: "请选择类型",
						trigger: "blur",
					},
				],
				title: [
					{
						required: true,
						message: "请输入标题",
						trigger: "blur",
					},
				],
				url: [
					{
						required: true,
						message: "请输入URL",
						trigger: "blur",
					},
					{ validator: checkUrl, trigger: "change" },
				],
			},
			// 富文本
			setting: {
				menubar: false,
				toolbar:
					"undo redo | fullscreen | formatselect alignleft aligncenter alignright alignjustify | link unlink | numlist bullist | image media table | fontselect fontsizeselect forecolor backcolor | bold italic underline strikethrough | indent outdent | superscript subscript | removeformat |",
				toolbar_drawer: "sliding",
				quickbars_selection_toolbar:
					"removeformat | bold italic underline strikethrough | fontsizeselect forecolor backcolor",
				plugins: "link image media table lists fullscreen quickbars",
				language: "zh_CN",
				height: 350,
			},
			productModels: [],
			tableData: [],
		};
	},
	mounted() {
		this.domain =
			window.location.href.indexOf("lexy.cn") != -1
				? "https://iot.lexy.cn/"
				: "https://laike-test.yunext.com/";
		this.form.url = this.domain + "files/course/course.html";
		this.getList();
		this.getProductModels();
	},
	methods: {
		getList: function (type, val, isReload = false) {
			isReload ? this.tableFilter.page = 1 : null;
			if (type) {
				this.tableFilter[type] = val;
			}
			this.$http.courses(this.tableFilter).then((res) => {
				this.tableData = res.data.data.list;
				this.total = res.data.data.total;
			});
		},
		// 添加
		handleAdd: function () {
			this.dialogVisible = true;
			this.act = "add";
		},
		// 编辑
		handleEdit: function (row) {
			this.$http.coursesInfo(row.id).then((res) => {
				this.act = "edit";
				this.dialogVisible = true;
				this.$nextTick(() => {
					this.form = res.data.data;
				});
			});
		},
		// 删除
		handleDelete: function (row) {
			this.$confirm(
				"确认删除此教程（" +
					row.title +
					"）吗？此内容显示在手机APP端，请慎重操作。",
				"提示",
				{
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				}
			).then(() => {
				this.$http.courseDelete(row.id).then((res) => {
					this.getList();
				});
			});
		},
		// 预览
		handlePreview: function (row) {
			this.$http.coursesInfo(row.id).then((res) => {
				let para = res.data.data;
				if (para.url) {
					window.open(para.url);
				} else {
					Message.info("地址未配置");
				}
			});
		},
		// 提交表单前
		beforeSubmit: function () {
			this.$refs.form.validate((valid) => {
				if (valid) {
					if (this.act == "edit") {
						this.$confirm(
							"确认编辑此教程吗？此内容显示在手机APP端，请慎重操作。",
							"提示",
							{
								confirmButtonText: "确定",
								cancelButtonText: "取消",
								type: "warning",
							}
						).then(() => {
							this.handleSubmit();
						});
					} else {
						this.handleSubmit();
					}
				}
			});
		},
		// 提交表单
		handleSubmit: function () {
			let ajax =
				this.act == "add"
					? this.$http.courseAdd
					: this.$http.courseEdit;
			let para = Object.assign({}, this.form);
			for (let i in para) {
				if (para[i] == null) {
					para[i] = "";
				}
			}
			ajax(para).then((res) => {
				if (res.data.success) {
					this.getList();
					this.handleClose();
				}
			});
		},
		// 关闭表单
		handleClose: function () {
			this.dialogVisible = false;
			this.$refs.form.resetFields();
			this.form.url = this.domain + "files/course/course.html";
		},
		// 重置筛选表单
		handleResetFilter: function () {
			this.$refs.tableFilter.resetFields();
		},
		// 复制
		handleCopyError: function () {
			Message.error("复制失败");
		},
		// 修改教程类型时
		handleChangeType: function (val) {
			if (val == 3 || val == 4) {
				this.form.productId = "";
			}
		},
		// 复制成功时
		handleCopySuccess: function () {
			Message.success("复制成功");
		},
		// ———————————— 获取关联数据 ————————————
		// 获取产品型号列表
		getProductModels: function () {
			this.$http.productModuleAll().then((res) => {
				if (res.data.success) {
					this.productModels = res.data.data;
				}
			});
		},
		// 处理表格数据
		dealTableData: function (type, value) {
			switch (type) {
				case "source":
					let result = false;
					for (let i in this.source) {
						if (value == this.source[i].value) {
							result = this.source[i].label;
						}
					}
					if (result != false) {
						return result;
					} else {
						return "--";
					}
					break;
				case "type":
					if (value == 1) {
						return "选型配网教程";
					} else if (value == 6) {
						return "重置wifi配网";
					} else if (value == 2) {
						return "扫码配网教程";
					} else if (value == 3) {
						return "使用教程";
					} else if (value == 4) {
						return "常见问题";
					} else if (value == 5) {
						return "产品教程";
					} else {
						return "--";
					}
				default:
					if (value) {
						return value;
					} else {
						return "--";
					}
			}
		},
		// 判断按钮权限
		btnPer: function (name) {
			let list = this.$store.state.standard.menuNodeList,
				flag = false;
			for (let i in list) {
				if (list[i].href == name) {
					flag = true;
					break;
				}
			}
			return flag;
		},
	},
};
</script>

<style lang='less' scoped>
.mce {
	height: 700rpx;
}
.formInput {
	width: 200px;
}
</style>